var transformSupported = false;
var transformChecked = false;

module.exports = {
    edge_top: 0,
    edge_left: 0,
    data_set: false,
    hash: {},
    document_offs: {},
    factory: function(content, drag, position, options){
      var _this = this;
      return function(e){
        var target = e.target,
        left, top;
        e.preventDefault();
        switch (e.type) {
          case "mousedown":
            if(content){
              drag.dragContent = content;
              drag.clientX = e.clientX;
              drag.clientY = e.clientY;
            }
            break;
          case "mousemove":
            if (drag.dragContent !== null) {
              let drag_left = position['margin-left'] + (e.clientX - drag.clientX);
              let drag_top = position['margin-top'] + (e.clientY - drag.clientY);
              if (drag_left <= _this.edge_left)  {
                drag_left = _this.edge_left
              }
              if (drag_top <= _this.edge_top)  {
                drag_top = _this.edge_top
              }
              if (!isNaN(_this.edge_bottom) && drag_top >= _this.edge_bottom)  {
                drag_top = _this.edge_bottom
              }
              if (!isNaN(_this.edge_right) && drag_left >= _this.edge_right)  {
                drag_left = _this.edge_right
              }
              drag.left = drag_left;
              drag.top = drag_top;
              this.move(content, drag);
            }
            break;
          case "mouseup":
          case "mouseout":
            if (drag.dragContent !== null && drag.left !== null && drag.top !== null) {
              drag.dragContent = null;
              position['margin-left'] = drag.left;
              position['margin-top'] = drag.top;
            }
            break;
        }
      };
    },
    move: function(content, drag){
      if (!transformChecked) this.transfromCheck(content);
      if(transformSupported){
        content.css('transform', 'translate(' + drag.left + 'px,' + drag.top + 'px)');
      }else{
        content.css({
          'margin-top': drag.top,
          'margin-left': drag.left
        });
      }
      content.data('draggable-x', drag.left).data('draggable-y', drag.top);
    },
    transfromCheck: function(element){
      var mousebar = element.find('.im-draggable-bar');
      mousebar.css('transform', 'translate(0px,0px)');
      transformSupported = mousebar.css('transform');
      transformChecked = true;
    },
    mount: function (element, options) {
      var _this = this;
      var content = element;
      if (!transformChecked) _this.transfromCheck(element);
      var mousebar = element.find('.im-draggable-bar');
      var element_no = options && options.document_move ? String(element) + (new Date()).valueOf() : element;
      this.hash[element_no] = this.factory(content, {
        dragContent: null,
        clientX: null,
        clientY: null,
        left: null,
        top: null
      },
      {
        height: null,
        width: null,
        'margin-top': content.data('draggable-y') || null,
        'margin-left': content.data('draggable-x') || null
      },
      options,
      transformSupported).bind(this);
      if(options && options.document_move){
        mousebar.on("mousedown", function(e){
          _this.hash[element_no](e);
          $(document).on('mousemove', _this.hash[element_no]);
          $(document).on('mouseup', _this.document_off(element_no));
        });
      }else{
        mousebar.on("mousedown mousemove mouseup mouseout", this.hash[element_no]);
      }
    },
    document_off: function (element_no) {
      var _this = this;
      if(this.document_offs[element_no]){
        //return this.document_offs[element];
      }else{
        this.document_offs[element_no] = function (e) {
          _this.hash[element_no](e);
          $(document).off('mousemove mouseup mouseout', _this.hash[element_no]);
          $(document).off('mouseup', _this.document_off(element_no));
        };
      }
      return this.document_offs[element_no];
    },
    unmount: function (ele) {
      var mousebar = element.find('.im-draggable-bar');
      if(this.hash[element])mousebar.off("mousedown mousemove mouseup mouseout", this.hash[element]);
      delete this.hash[element];
    },
    setData: function (data) {
      if (data) {
        if (!isNaN(data.edge_left)) {
          this.edge_left = data.edge_left;
          this.data_set = true;
        }
        if (!isNaN(data.edge_top)) {
          this.edge_top = data.edge_top;
          this.data_set = true;
        }
        if (!isNaN(data.edge_bottom)) {
          this.edge_bottom = data.edge_bottom;
          this.data_set = true;
        }
        if (!isNaN(data.edge_right)) {
          this.edge_right = data.edge_right;
          this.data_set = true;
        }
      }
    }
};
